export const tableLocation = {
    data() {
        return {
            tableColumns: [
                { title: this.$t('Name'), type: 'text', key: 'Second_Title' },
                { title: this.$t('Description'), type: 'text', key: 'description' },
                { title: this.$t('Fda'), type: 'text', key: 'fda' },
                { title: this.$t('Fax'), type: 'text', key: 'fax' },
                { title: this.$t('Email'), type: 'text', key: 'Email' },
                { title: this.$t('Phone'), type: 'text', key: 'phone' },
                {
                    title: this.$t('Status'), type: 'custom-html', key: 'status',
                    modifier: (value) => {
                        if (value) {
                            let className = 'danger';
                            if (value === 'active') className = 'success';
                            else if (value === 'invited') className = 'warning';
                            return `<span class="badge badge-sm badge-pill badge-${className}">${this.$t(value)}</span>`;
                        }
                        return '';
                    }
                },
                {
                    title: this.$t('action'),
                    type: 'action', // Añadir tipo 'action' para las acciones
                }
            ]
        };
    }
}